export default "__VITE_ASSET__BBpC0QXc__"